import * as ngCore from '@angular/core'

import * as illustrations from '../../../illustrations'
import * as loader from '../../../loader'
import type * as helpers from '../../helpers'

/** Renders the prepared loading, error, or empty table presentation. */
@ngCore.Component({
  imports: [illustrations.emptyState.Component, loader.Component],
  selector: 'atn-ds-table-status',
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** Prepared non-data presentation. */
  public readonly statusSg = ngCore.input.required<helpers.Status>({
    alias: 'status',
  })
}
